import { NousCore } from "nouscore-js-api";
import { Shark } from "shark-mvc";

import ManagerBase from "./ManagerBase";

class VolumeManager extends ManagerBase {
	constructor () {
		super("volumeManager");
		this.remoteClassName = "volume";
	}

	async getListByVolumeCollectionGuid (volumeCollectionGuid) {
		const rd = NousCore.api.createRequest({ filters: { volumeCollectionGuid } });
		const requestedAction = "get-by-volume-collection-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}

const volumeManager = new VolumeManager();

Shark.registerController(volumeManager);

export default volumeManager;
